export default __webpack_public_path__ + "static/media/Boss-right.2e94b8e5.png";